import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TrainingService } from '../training.service';

@Component({
  selector: 'app-begin-course-modal',
  templateUrl: './begin-course-modal.component.html',
  styleUrls: ['./begin-course-modal.component.css']
})
export class BeginCourseModalComponent implements OnInit {
  courses: any[] = [];
  selectedCourse: any = null;
  loading = false;

  constructor(
    public dialogRef: MatDialogRef<BeginCourseModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private trainingService: TrainingService
  ) {
    this.courses = data.courses || [];
  }

  ngOnInit(): void {}

  /** True if this course is already completed by the employee (from employee.courses). */
  isCourseCompleted(course: any): boolean {
    const completed = this.data.employee?.courses || [];
    return completed.some((c: any) => String(c.course_id) === String(course?.id));
  }

  selectCourse(course: any): void {
    if (this.isCourseCompleted(course)) return;
    this.selectedCourse = course;
  }

  enroll(course?: any): void {
    const courseToEnroll = course || this.selectedCourse;
    if (!courseToEnroll || !this.data.employee) {
      return;
    }

    this.selectedCourse = courseToEnroll;
    this.loading = true;
    this.trainingService.createEnrollment(
      this.data.employee.employee_id,
      courseToEnroll.id,
      this.data.managerId
    ).subscribe(
      (response) => {
        if (!response.Error) {
          this.dialogRef.close({ success: true, enrollment: response });
        } else {
          alert('Error: ' + response.Message);
          this.loading = false;
        }
      },
      (error) => {
        console.error('Error enrolling:', error);
        alert('Error enrolling employee in course');
        this.loading = false;
      }
    );
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
